export { default as MainC } from './components/main';
export { default as AddC } from './components/add';
export { default as ItemListC } from './components/itemList';



// WEBPACK FOOTER //
// src/modules/grupos/component.js